import React from 'react';
import {Text, Link} from '@sitecore-jss/sitecore-jss-react';
import ThirtyThreeSplitContainer from '../../containers/ThirtyThreeSplitContainer/ThirtyThreeSplitContainer';
import {DefaultProps, PropTypes} from '../../../core/Utils/SitecoreFields';

const YourCochlearStories = ({fields, rendering}) => {
	return (
		<div className="your-cochlear-stories">
			<div className="l-padding">
				<div className="description">
					<Text field={fields.title} tag="h2" />
					<Text field={fields.description} tag="p" />
					<Link field={fields.link} className="cta-button tertiary" />
				</div>
				<ThirtyThreeSplitContainer
					rendering={rendering}
					noPadding
					animation={fields.hasFade.value}
				/>
			</div>
		</div>
	);
};

YourCochlearStories.propTypes = PropTypes.SitecoreItem.inject({
	...PropTypes.ContentBlock,
	link: PropTypes.Link,
	hasFade: PropTypes.Checkbox,
});

YourCochlearStories.defaultProps = DefaultProps.SitecoreItem.inject({
	...DefaultProps.ContentBlock,
	link: DefaultProps.Link,
	hasFade: DefaultProps.Checkbox,
});

export default YourCochlearStories;
